package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.LinhaKpis
import br.com.htms.inspeccaocampo.ui.kit.Kpi
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.Icons
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardInspecoes
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.RemoteInspection
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.data.InspecaoCompleta
import br.com.htms.inspeccaocampo.export.ExportNames
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.platform.formatDateBr
import br.com.htms.inspeccaocampo.platform.formatDateTimeBr
import br.com.htms.inspeccaocampo.platform.formatMonthYearPt
import br.com.htms.inspeccaocampo.platform.monthOf
import br.com.htms.inspeccaocampo.platform.yearOf
import br.com.htms.inspeccaocampo.shared.ui.components.ButtonLoadingContent
import br.com.htms.inspeccaocampo.shared.ui.components.CenteredAppDialog
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import androidx.compose.material3.Button
import androidx.compose.material3.Checkbox
import androidx.compose.material3.ButtonDefaults
import androidx.compose.foundation.layout.Spacer
import androidx.compose.ui.graphics.Color
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedHistoricoScreen(
    controller: AppController,
    snackbar: SnackbarHostState
) {
    val inspecoes by controller.inspecoes.collectAsState()
    val remotas by controller.remoteInspections.collectAsState()
    val remDossiers by controller.remDossiers.collectAsState()
    val remExportandoId by controller.remExportandoId.collectAsState()
    val acompAmbDossiers by controller.acompAmbDossiers.collectAsState()
    val acompAmbExportandoId by controller.acompAmbExportandoId.collectAsState()
    val relSegDossiers by controller.relSegDossiers.collectAsState()
    val relSegExportandoId by controller.relSegExportandoId.collectAsState()
    val historico by controller.historico.collectAsState()
    val authUser by controller.authUser.collectAsState()
    val appConfig by controller.appConfig.collectAsState()
    val isAdmin = authUser?.isAdmin == true
    val tiposPermitidos = remember(authUser, appConfig) {
        authUser?.allowedFormTipos(appConfig) ?: FormTipo.entries
    }
    val remPermitido = remember(tiposPermitidos) {
        FormTipo.REM_SEGURANCA_OBRAS in tiposPermitidos
    }
    val acompAmbPermitido = remember(tiposPermitidos) {
        FormTipo.ACOMPANHAMENTO_AMBIENTAL in tiposPermitidos
    }
    val relSegPermitido = remember(tiposPermitidos) {
        FormTipo.RELATORIO_SEGURANCA in tiposPermitidos
    }

    LaunchedEffect(Unit) {
        controller.atualizarHistoricoRemoto()
    }

    val remotasVisiveis = remember(remotas, authUser, appConfig) {
        remotas.filter { r ->
            val tipo = FormTipo.fromId(r.formType)
            tipo != FormTipo.RELATORIO_SEGURANCA &&
                tipo != FormTipo.REM_SEGURANCA_OBRAS &&
                tipo != FormTipo.ACOMPANHAMENTO_AMBIENTAL &&
                (FormTipo.ANALISE_VISUAL_NR_ATIVA || tipo != FormTipo.ANALISE_VISUAL_NR) &&
                authUser?.canExportForm(tipo, appConfig) != false
        }
    }
    val inspecoesVisiveis = remember(inspecoes, authUser, appConfig) {
        inspecoes.filter { insp ->
            (FormTipo.ANALISE_VISUAL_NR_ATIVA || insp.formTipo != FormTipo.ANALISE_VISUAL_NR) &&
                authUser?.canExportForm(insp.formTipo, appConfig) != false
        }
    }

    val meses = remember(inspecoesVisiveis) {
        inspecoesVisiveis
            .map { yearOf(it.criadoEm) to monthOf(it.criadoEm) }
            .distinct()
            .sortedWith(compareByDescending<Pair<Int, Int>> { it.first }.thenByDescending { it.second })
    }
    var mesSelecionado by remember(meses) { mutableStateOf(meses.firstOrNull()) }
    var menuMesAberto by remember { mutableStateOf(false) }

    var filtroTexto by remember { mutableStateOf("") }
    var filtroUsuario by remember { mutableStateOf<String?>(null) }
    var filtroDe by remember { mutableStateOf("") }
    var filtroAte by remember { mutableStateOf("") }
    var menuUsuarioAberto by remember { mutableStateOf(false) }
    var confirmarExclusao by remember { mutableStateOf<RemoteInspection?>(null) }
    var confirmarExclusaoRem by remember { mutableStateOf<br.com.htms.inspeccaocampo.data.RemDossier?>(null) }
    var confirmarExclusaoAcompAmb by remember { mutableStateOf<br.com.htms.inspeccaocampo.data.AcompAmbDossier?>(null) }
    var confirmarExclusaoRelSeg by remember { mutableStateOf<br.com.htms.inspeccaocampo.data.RelSegDossier?>(null) }

    /** Tipos incluídos no Excel consolidado (subset dos permitidos; REM/RelSeg têm dossiê próprio). */
    val tiposConsolidaveis = remember(tiposPermitidos) {
        tiposPermitidos.filter {
            it != FormTipo.RELATORIO_SEGURANCA &&
                it != FormTipo.REM_SEGURANCA_OBRAS &&
                it != FormTipo.ACOMPANHAMENTO_AMBIENTAL &&
                (FormTipo.ANALISE_VISUAL_NR_ATIVA || it != FormTipo.ANALISE_VISUAL_NR)
        }
    }
    var tiposConsolidado by remember(tiposConsolidaveis) {
        mutableStateOf(tiposConsolidaveis.toSet())
    }
    var consolidadoAberto by remember { mutableStateOf(false) }

    val usuariosRemotos = remember(remotasVisiveis) {
        remotasVisiveis.mapNotNull { it.username?.takeIf { u -> u.isNotBlank() } }
            .distinct()
            .sorted()
    }

    fun bateTexto(haystack: String, needle: String): Boolean {
        if (needle.isBlank()) return true
        return haystack.contains(needle, ignoreCase = true)
    }

    val deYmd = remember(filtroDe) { parseDateBrYmd(filtroDe) }
    val ateYmd = remember(filtroAte) { parseDateBrYmd(filtroAte) }

    val filtroRemota = remember(filtroTexto, filtroUsuario, deYmd, ateYmd) {
        val q = filtroTexto.trim()
        val usuario = filtroUsuario
        val pred: (RemoteInspection) -> Boolean = pred@{ r ->
            val userOk = usuario == null || r.username.equals(usuario, ignoreCase = true)
            if (!userOk) return@pred false
            val whenMs = r.dataHorarioMs ?: r.createdAt
            if (!dataNoPeriodo(whenMs, deYmd, ateYmd)) return@pred false
            if (q.isBlank()) return@pred true
            val blob = buildString {
                append(r.username.orEmpty()); append(' ')
                append(r.summaryTst); append(' ')
                append(r.summaryLocal); append(' ')
                append(r.summaryEfetivo.orEmpty()); append(' ')
                append(r.summaryObra.orEmpty()); append(' ')
                append(r.formTipoRotulo); append(' ')
                append(formatDateTimeBr(r.createdAt))
            }
            bateTexto(blob, q)
        }
        pred
    }
    val remotasFiltradas = remember(remotasVisiveis, filtroRemota) {
        remotasVisiveis.filter(filtroRemota)
    }

    val locaisFiltradas = remember(inspecoesVisiveis, filtroTexto, deYmd, ateYmd) {
        val q = filtroTexto.trim()
        inspecoesVisiveis.filter { insp ->
            if (!dataNoPeriodo(insp.criadoEm, deYmd, ateYmd)) return@filter false
            if (q.isBlank()) return@filter true
            val blob = buildString {
                append(insp.rotuloTipo); append(' ')
                append(insp.responsavelResumo()); append(' ')
                append(insp.obraResumo()); append(' ')
                append(insp.localResumo()); append(' ')
                append(insp.form.efetivo); append(' ')
                append(formatDateTimeBr(insp.criadoEm))
            }
            bateTexto(blob, q)
        }
    }

    val remotasParaConsolidado = remember(remotasFiltradas, tiposConsolidado) {
        remotasFiltradas.filter { FormTipo.fromId(it.formType) in tiposConsolidado }
    }
    val locaisParaConsolidadoBase = remember(locaisFiltradas, remotasFiltradas, isAdmin) {
        if (isAdmin) emptyList()
        else {
            val remoteLocalIds = remotasFiltradas.mapNotNull { it.localId }.toSet()
            locaisFiltradas.filter { it.id !in remoteLocalIds }
        }
    }
    val locaisParaConsolidado = remember(locaisParaConsolidadoBase, tiposConsolidado) {
        locaisParaConsolidadoBase.filter { it.formTipo in tiposConsolidado }
    }

    val totalConsolidado = remember(remotasParaConsolidado, locaisParaConsolidado, isAdmin) {
        if (isAdmin) remotasParaConsolidado.size
        else remotasParaConsolidado.size + locaisParaConsolidado.size
    }

    LaunchedEffect(historico.mensagem) {
        historico.mensagem?.let {
            snackbar.showSnackbar(it)
            controller.limparMensagemHistorico()
        }
    }

    confirmarExclusao?.let { alvo ->
        CenteredAppDialog(
            onDismissRequest = { confirmarExclusao = null },
            title = "Excluir inspeção",
            text = buildString {
                append("Mover esta vistoria para a lixeira")
                if (!alvo.username.isNullOrBlank()) {
                    append(" (")
                    append(alvo.username)
                    append(")")
                }
                append("? Ela poderá ser recuperada por 7 dias em Configuração → Lixeira.")
            },
            confirmLabel = "Mover para lixeira",
            onConfirm = {
                controller.excluirRemoto(alvo.id)
                confirmarExclusao = null
            },
            dismissLabel = "Cancelar"
        )
    }

    confirmarExclusaoRelSeg?.let { alvo ->
        CenteredAppDialog(
            onDismissRequest = { confirmarExclusaoRelSeg = null },
            title = "Excluir Relatório de segurança",
            text = "Mover o dossiê de ${alvo.obra} (${alvo.mes.toString().padStart(2,'0')}/${alvo.ano}) para a lixeira? Poderá ser recuperado por 7 dias em Configuração → Lixeira.",
            confirmLabel = "Mover para lixeira",
            onConfirm = {
                controller.excluirRelSegDossier(alvo.id)
                confirmarExclusaoRelSeg = null
            },
            dismissLabel = "Cancelar"
        )
    }

    confirmarExclusaoRem?.let { alvo ->
        CenteredAppDialog(
            onDismissRequest = { confirmarExclusaoRem = null },
            title = "Excluir dossiê REM",
            text = "Mover o dossiê REM de ${alvo.obra} (${alvo.ano}) para a lixeira? Poderá ser recuperado por 7 dias em Configuração → Lixeira.",
            confirmLabel = "Mover para lixeira",
            onConfirm = {
                controller.excluirRemDossier(alvo.id)
                confirmarExclusaoRem = null
            },
            dismissLabel = "Cancelar"
        )
    }

    confirmarExclusaoAcompAmb?.let { alvo ->
        CenteredAppDialog(
            onDismissRequest = { confirmarExclusaoAcompAmb = null },
            title = "Excluir Acompanhamento Ambiental",
            text = "Mover o dossiê de ${alvo.obra} (${alvo.ano}) para a lixeira? Poderá ser recuperado por 7 dias em Configuração → Lixeira.",
            confirmLabel = "Mover para lixeira",
            onConfirm = {
                controller.excluirAcompAmbDossier(alvo.id)
                confirmarExclusaoAcompAmb = null
            },
            dismissLabel = "Cancelar"
        )
    }

    val pendentesLocais = remember(inspecoes) { inspecoes.count { !it.enviadoRemoto } }
    val totalLista = if (isAdmin) remotasFiltradas.size
        else remotasFiltradas.size + locaisParaConsolidadoBase.size
    val filtrosAtivos = filtroTexto.isNotBlank() || filtroUsuario != null ||
        filtroDe.isNotBlank() || filtroAte.isNotBlank()

    // Admin também pode ter locais neste aparelho (reenvio órfão).
    val remVisiveis = if (remPermitido) remDossiers else emptyList()
    val acompAmbVisiveis = if (acompAmbPermitido) acompAmbDossiers else emptyList()
    val relSegVisiveis = if (relSegPermitido) relSegDossiers else emptyList()
    val vazio = inspecoesVisiveis.isEmpty() && remotasVisiveis.isEmpty() &&
        remVisiveis.isEmpty() && acompAmbVisiveis.isEmpty() && relSegVisiveis.isEmpty()
    if (vazio) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .background(MaterialTheme.colorScheme.background)
                .padding(24.dp),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                if (isAdmin) "Nenhuma inspeção no servidor (últimos 60 dias) para o seu perfil."
                else "Nenhuma inspeção salva ainda.",
                style = MaterialTheme.typography.titleMedium
            )
            Text(
                if (isAdmin) "Quando os usuários salvarem inspeções dos tipos do seu perfil, elas aparecerão aqui."
                else "Preencha um formulário na aba Formulários e toque em Salvar.",
                style = MaterialTheme.typography.bodyMedium,
                modifier = Modifier.padding(top = 8.dp)
            )
            Text(
                "Histórico no servidor: 60 dias.",
                style = MaterialTheme.typography.bodySmall,
                modifier = Modifier.padding(top = 12.dp)
            )
            Text(
                "Se um envio ficou só neste aparelho, use Sincronizar (dados locais dos últimos 60 dias).",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.padding(top = 12.dp)
            )
            PortalButton(
                onClick = { controller.sincronizarPendentes() },
                enabled = !historico.sincronizandoPendentes,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 16.dp)
            ) {
                ButtonLoadingContent(
                    loading = historico.sincronizandoPendentes,
                    idleText = if (pendentesLocais > 0) {
                        "Sincronizar ($pendentesLocais pendente(s))"
                    } else {
                        "Sincronizar / reenviar pendentes"
                    },
                    loadingText = "Sincronizando..."
                )
            }
        }
        return
    }

    var aba by remember { mutableStateOf("INSPECOES") }
    val totalDossies = remVisiveis.size + acompAmbVisiveis.size + relSegVisiveis.size
    val itensMenu = buildList {
        add(PortalMenuItem("INSPECOES", "Inspeções", Icons.Filled.List))
        add(PortalMenuItem("DASHBOARD", "Dashboard", Icons.Filled.Star))
        if (totalDossies > 0) add(PortalMenuItem("DOSSIES", "Dossiês por obra", Icons.Filled.DateRange))
        if (isAdmin && tiposConsolidaveis.isNotEmpty()) add(PortalMenuItem("CONSOLIDADO", "Excel consolidado", Icons.Filled.Build))
        if (inspecoesVisiveis.isNotEmpty()) {
            add(PortalMenuItem("APARELHO", "Neste aparelho", Icons.Filled.Home, destaque = pendentesLocais > 0))
        }
    }
    val abaAtual = if (itensMenu.any { it.chave == aba }) aba else "INSPECOES"

    val filtros: @Composable () -> Unit = {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(Modifier.weight(1f)) {
                    Text(
                        "Consultar inspeções",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleMedium,
                        color = PortalCores.Navy
                    )
                    Text(
                        "Filtra a lista abaixo (últimos 60 dias).",
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
                TextButton(
                    onClick = { controller.atualizarHistoricoRemoto() },
                    enabled = !historico.sincronizandoPendentes &&
                        !historico.exportandoConsolidado &&
                        !historico.exportandoLote
                ) { Text("Atualizar lista") }
            }
            AppOutlinedTextField(
                value = filtroTexto,
                onValueChange = { filtroTexto = it },
                label = { Text("Buscar por obra, nome, local ou data") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            if (isAdmin && usuariosRemotos.isNotEmpty()) {
                br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                    label = "Usuário",
                    opcoes = listOf("" to "Todos os usuários") + usuariosRemotos.map { it to it },
                    selecionado = filtroUsuario.orEmpty(),
                    onSelect = { filtroUsuario = it.ifBlank { null } }
                )
            }
            Text(
                "Período",
                style = MaterialTheme.typography.labelLarge,
                fontWeight = FontWeight.SemiBold
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                AppDateTextField(
                    value = filtroDe,
                    onValueChange = { filtroDe = it },
                    label = "De",
                    kind = DateFieldKind.DATE,
                    singleLine = true,
                    modifier = Modifier.weight(1f),
                    isError = filtroDe.isNotBlank() && deYmd == null
                )
                AppDateTextField(
                    value = filtroAte,
                    onValueChange = { filtroAte = it },
                    label = "Até",
                    kind = DateFieldKind.DATE,
                    singleLine = true,
                    modifier = Modifier.weight(1f),
                    isError = filtroAte.isNotBlank() && ateYmd == null
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    "${totalLista} resultado(s) na lista",
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.Medium,
                    modifier = Modifier.weight(1f)
                )
                if (filtrosAtivos) {
                    TextButton(onClick = {
                        filtroTexto = ""
                        filtroUsuario = null
                        filtroDe = ""
                        filtroAte = ""
                    }) { Text("Limpar filtros") }
                }
            }
        }
    }

    }

    PortalModulo(
        titulo = "Histórico",
        itens = itensMenu,
        selecionado = abaAtual,
        onSelect = { aba = it },
        extraCabecalho = {
            TextButton(
                onClick = { controller.atualizarHistoricoRemoto() },
                enabled = !historico.sincronizandoPendentes &&
                    !historico.exportandoConsolidado &&
                    !historico.exportandoLote
            ) {
                Icon(Icons.Filled.Refresh, contentDescription = null, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(6.dp))
                Text("Atualizar lista")
            }
        }
    ) { largo ->
        if (abaAtual == "DASHBOARD") {
            DashboardInspecoes(controller)
            return@PortalModulo
        }
        if (pendentesLocais > 0) {
            Card(
                modifier = Modifier.fillMaxWidth(),
                colors = CardDefaults.cardColors(containerColor = Color(0xFFFFF3CD))
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(12.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(10.dp)
                ) {
                    Column(Modifier.weight(1f)) {
                        Text(
                            "⚠ $pendentesLocais formulário(s) não enviado(s)",
                            fontWeight = FontWeight.Bold,
                            color = Color(0xFF856404)
                        )
                        Text(
                            "Ficaram salvos só neste aparelho. Toque em Reenviar para mandar ao servidor.",
                            style = MaterialTheme.typography.bodySmall,
                            color = Color(0xFF856404)
                        )
                    }
                    PortalButton(
                        onClick = { controller.sincronizarPendentes() },
                        enabled = !historico.sincronizandoPendentes &&
                            !historico.exportandoConsolidado &&
                            !historico.exportandoLote,
                        colors = ButtonDefaults.buttonColors(
                            containerColor = Color(0xFF856404),
                            contentColor = Color.White
                        )
                    ) {
                        ButtonLoadingContent(
                            loading = historico.sincronizandoPendentes,
                            idleText = "Reenviar",
                            loadingText = "Enviando..."
                        )
                    }
                }
            }
        }

        LinhaKpis(largo) { m ->
            Kpi("No servidor", remotasVisiveis.size.toString(), Icons.Filled.List, m, legenda = "Últimos 60 dias", onClick = { aba = "INSPECOES" })
            Kpi("Dossiês por obra", totalDossies.toString(), Icons.Filled.DateRange, m, onClick = { aba = "DOSSIES" })
            Kpi(
                "Pendentes de envio",
                pendentesLocais.toString(),
                Icons.Filled.Warning,
                m,
                alerta = pendentesLocais > 0,
                legenda = "Salvos só neste aparelho",
                onClick = { aba = "APARELHO" }
            )
        }
        when (abaAtual) {
            "DOSSIES" -> {
                if (remVisiveis.isNotEmpty()) {
                    Text(
                        "REM Segurança — Obras",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleMedium,
                        modifier = Modifier.padding(top = 8.dp),
                        color = PortalCores.Navy
                    )
                    Text(
                        "Dossiês compartilhados por obra/ano (todos os TSTs). Baixe o Excel; somente admin edita ou exclui pelo Histórico.",
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                    remVisiveis.forEach { dossier ->
                        RemDossierHistoricoCard(
                            dossier = dossier,
                            showUser = isAdmin,
                            canEdit = isAdmin,
                            exportando = remExportandoId == dossier.id,
                            onAbrir = { controller.abrirRemDossierDoHistorico(dossier.id) },
                            onExcel = {
                                controller.baixarRemExcelDoHistorico(dossier.id, dossier.obra, dossier.ano)
                            },
                            onExcluir = { confirmarExclusaoRem = dossier }
                        )
                    }
                }

                if (acompAmbVisiveis.isNotEmpty()) {
                    Text(
                        "Acompanhamento Ambiental",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleMedium,
                        modifier = Modifier.padding(top = 8.dp),
                        color = PortalCores.Navy
                    )
                    Text(
                        "Dossiês compartilhados por obra/ano. Baixe o Excel; somente admin edita ou exclui pelo Histórico.",
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                    acompAmbVisiveis.forEach { dossier ->
                        AcompAmbDossierHistoricoCard(
                            dossier = dossier,
                            showUser = isAdmin,
                            canEdit = isAdmin,
                            exportando = acompAmbExportandoId == dossier.id,
                            onAbrir = { controller.abrirAcompAmbDossierDoHistorico(dossier.id) },
                            onExcel = {
                                controller.baixarAcompAmbExcelDoHistorico(dossier.id, dossier.obra, dossier.ano)
                            },
                            onExcluir = { confirmarExclusaoAcompAmb = dossier }
                        )
                    }
                }

                if (relSegVisiveis.isNotEmpty()) {
                    Text(
                        "Relatório de segurança",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleMedium,
                        modifier = Modifier.padding(top = 8.dp),
                        color = PortalCores.Navy
                    )
                    Text(
                        "Dossiês mensais compartilhados por obra. Sem expiração (retenção longa — exigência ~40 dias). Baixe o PPTX; somente admin edita ou exclui pelo Histórico.",
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                    relSegVisiveis.forEach { dossier ->
                        RelSegDossierHistoricoCard(
                            dossier = dossier,
                            showUser = isAdmin,
                            canEdit = isAdmin,
                            exportando = relSegExportandoId == dossier.id,
                            onAbrir = { controller.abrirRelSegDossierDoHistorico(dossier.id) },
                            onPptx = {
                                controller.baixarRelSegPptxDoHistorico(dossier.id, dossier.obra, dossier.ano, dossier.mes)
                            },
                            onExcluir = { confirmarExclusaoRelSeg = dossier }
                        )
                    }
                }

            }
            "CONSOLIDADO" -> {
                filtros()
                if (isAdmin && tiposConsolidaveis.isNotEmpty()) {
                    Card(
                        modifier = Modifier.fillMaxWidth(),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
                    ) {
                        Column(
                            modifier = Modifier.padding(12.dp),
                            verticalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Column(Modifier.weight(1f)) {
                                    Text(
                                        "Excel consolidado",
                                        fontWeight = FontWeight.Bold,
                                        style = MaterialTheme.typography.titleMedium,
                                        color = PortalCores.Navy
                                    )
                                    Text(
                                        "Uma planilha com várias inspeções juntas (inclui as com mais de 60 dias).",
                                        style = MaterialTheme.typography.bodySmall,
                                        color = MaterialTheme.colorScheme.onSurfaceVariant
                                    )
                                }
                                TextButton(onClick = { consolidadoAberto = !consolidadoAberto }) {
                                    Text(if (consolidadoAberto) "Ocultar" else "Abrir")
                                }
                            }
                            if (consolidadoAberto) {
                                Text(
                                    "Usa a busca, o usuário e o período escolhidos em \"Consultar inspeções\":",
                                    style = MaterialTheme.typography.bodySmall
                                )
                                Text(
                                    buildString {
                                        append("• Usuário: ")
                                        append(filtroUsuario ?: "todos")
                                        append("\n• Período: ")
                                        append(
                                            when {
                                                filtroDe.isBlank() && filtroAte.isBlank() -> "todo o histórico"
                                                filtroDe.isBlank() -> "até ${filtroAte.trim()}"
                                                filtroAte.isBlank() -> "a partir de ${filtroDe.trim()}"
                                                else -> "${filtroDe.trim()} a ${filtroAte.trim()}"
                                            }
                                        )
                                        if (filtroTexto.isNotBlank()) {
                                            append("\n• Busca: \"")
                                            append(filtroTexto.trim())
                                            append("\"")
                                        }
                                    },
                                    style = MaterialTheme.typography.bodyMedium,
                                    fontWeight = FontWeight.Medium
                                )
                                Row(
                                    modifier = Modifier.fillMaxWidth(),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Text(
                                        "Tipos de formulário",
                                        style = MaterialTheme.typography.labelLarge,
                                        fontWeight = FontWeight.SemiBold,
                                        modifier = Modifier.weight(1f)
                                    )
                                    val todosMarcados = tiposConsolidado.size == tiposConsolidaveis.size
                                    TextButton(onClick = {
                                        tiposConsolidado = if (todosMarcados) emptySet() else tiposConsolidaveis.toSet()
                                    }) { Text(if (todosMarcados) "Desmarcar todos" else "Marcar todos") }
                                }
                                tiposConsolidaveis.chunked(2).forEach { par ->
                                    Row(Modifier.fillMaxWidth()) {
                                        par.forEach { tipo ->
                                            Row(
                                                modifier = Modifier.weight(1f),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                Checkbox(
                                                    checked = tipo in tiposConsolidado,
                                                    onCheckedChange = { checked ->
                                                        tiposConsolidado = if (checked) {
                                                            tiposConsolidado + tipo
                                                        } else {
                                                            tiposConsolidado - tipo
                                                        }
                                                    }
                                                )
                                                Text(tipo.rotulo, style = MaterialTheme.typography.bodyMedium)
                                            }
                                        }
                                        if (par.size == 1) Spacer(Modifier.weight(1f))
                                    }
                                }
                                Text(
                                    "REM, Relatório de segurança e Acompanhamento Ambiental têm Excel próprio na lista abaixo.",
                                    style = MaterialTheme.typography.bodySmall,
                                    color = MaterialTheme.colorScheme.onSurfaceVariant
                                )
                                PortalButton(
                                    onClick = {
                                        val deMs = remotasParaConsolidado.map { it.dataHorarioMs ?: it.createdAt } +
                                            locaisParaConsolidado.map {
                                                it.dataHorarioMsResumo().takeIf { ms -> ms > 0 } ?: it.criadoEm
                                            }
                                        val fromEpoch = deYmd?.let { ymdToEpochMs(it, endOfDay = false) }
                                        val toEpoch = ateYmd?.let { ymdToEpochMs(it, endOfDay = true) }
                                        controller.exportarConsolidado(
                                            remotas = remotasParaConsolidado,
                                            locais = locaisParaConsolidado,
                                            deLabel = filtroDe.trim().ifBlank {
                                                deMs.minOrNull()?.let { formatDateBr(it) }.orEmpty()
                                            },
                                            ateLabel = filtroAte.trim().ifBlank {
                                                deMs.maxOrNull()?.let { formatDateBr(it) }.orEmpty()
                                            },
                                            tiposPermitidos = tiposConsolidado,
                                            fromMs = fromEpoch,
                                            toMs = toEpoch,
                                            filtroRemota = filtroRemota
                                        )
                                    },
                                    enabled = tiposConsolidado.isNotEmpty() &&
                                        !historico.exportandoConsolidado &&
                                        !historico.exportandoLote &&
                                        (filtroDe.isBlank() || deYmd != null) &&
                                        (filtroAte.isBlank() || ateYmd != null),
                                    modifier = Modifier.fillMaxWidth()
                                ) {
                                    ButtonLoadingContent(
                                        loading = historico.exportandoConsolidado,
                                        idleText = "Baixar Excel consolidado",
                                        loadingText = "Gerando Excel..."
                                    )
                                }
                                if (tiposConsolidado.isEmpty()) {
                                    Text(
                                        "Marque pelo menos um tipo de formulário.",
                                        style = MaterialTheme.typography.bodySmall,
                                        color = MaterialTheme.colorScheme.error
                                    )
                                }
                            }
                        }
                    }
                }

            }
            "APARELHO" -> {
                filtros()
                if (inspecoesVisiveis.isNotEmpty()) {
                    Text(
                        if (isAdmin) "Neste aparelho (pendentes / locais)"
                        else "Neste aparelho",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleMedium,
                        modifier = Modifier.padding(top = 8.dp)
                    )
                    if (!isAdmin) {
                    Card(
                        modifier = Modifier.fillMaxWidth(),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
                    ) {
                        Column(
                            modifier = Modifier.padding(12.dp),
                            verticalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            Text("Exportar mês (ZIP com PDF + Excel)", fontWeight = FontWeight.SemiBold)
                            if (meses.isNotEmpty() && mesSelecionado != null) {
                                val (ano, mes) = mesSelecionado!!
                                val rotuloMes = formatMonthYearPt(ano, mes)
                                val qtd = inspecoesVisiveis.count {
                                    yearOf(it.criadoEm) == ano && monthOf(it.criadoEm) == mes
                                }
                                br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                                    label = "Mês ($qtd inspeções)",
                                    opcoes = meses.map { "${it.first}-${it.second}" to formatMonthYearPt(it.first, it.second) },
                                    selecionado = "$ano-$mes",
                                    onSelect = { k -> meses.firstOrNull { "${it.first}-${it.second}" == k }?.let { mesSelecionado = it } }
                                )
                                PortalOutlinedButton(
                                    onClick = { controller.exportarMes(ano, mes) },
                                    enabled = !historico.exportandoLote && qtd > 0,
                                    modifier = Modifier.fillMaxWidth()
                                ) {
                                    ButtonLoadingContent(
                                        loading = historico.exportandoLote,
                                        loadingText = "Gerando ZIP...",
                                        idleText = "Exportar $rotuloMes"
                                    )
                                }
                            }
                        }
                    }
                    }

                    if (locaisFiltradas.isEmpty()) {
                        Text(
                            "Nenhuma inspeção local corresponde à busca.",
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    } else {
                        locaisFiltradas.forEach { inspecao ->
                            HistoricoCard(
                                inspecao = inspecao,
                                exportando = historico.exportandoId == inspecao.id || historico.exportandoLote,
                                sincronizando = historico.sincronizandoPendentes,
                                onEditar = { controller.carregarParaEdicao(inspecao) },
                                onPdf = { controller.exportarPdf(inspecao) },
                                onExcel = { controller.exportarExcel(inspecao) },
                                onReenviar = { controller.sincronizarPendentes() }
                            )
                        }
                    }
                }
            }
            else -> {
                filtros()
                if (remotasVisiveis.isNotEmpty()) {
                    Text(
                        if (isAdmin) "Servidor — inspeções do seu perfil (60 dias · PDF/Excel)"
                        else "Servidor — minhas inspeções (60 dias · PDF/Excel)",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleMedium
                    )
                    if (remotasFiltradas.isEmpty()) {
                        Text(
                            "Nenhuma inspeção corresponde aos filtros.",
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    } else {
                        remotasFiltradas.forEach { remota ->
                            val ocupado =
                                historico.exportandoRemoteId == remota.id ||
                                    historico.gerandoAnexosRemoteId == remota.id ||
                                    historico.exportandoLote
                            RemotoCard(
                                remota = remota,
                                showUser = isAdmin,
                                canDelete = isAdmin,
                                canForceGenerate = isAdmin && remota.hasJson,
                                baixandoPdf = historico.exportandoRemoteId == remota.id &&
                                    historico.baixandoRemotoKind == "pdf",
                                baixandoExcel = historico.exportandoRemoteId == remota.id &&
                                    historico.baixandoRemotoKind == "excel",
                                gerandoAnexos = historico.gerandoAnexosRemoteId == remota.id,
                                ocupado = ocupado,
                                onPdf = {
                                    val name = ExportNames.remotePdf(
                                        stored = remota.pdfFileName,
                                        dataHorarioMs = remota.dataHorarioMs,
                                        createdAt = remota.createdAt,
                                        tstResponsavel = remota.summaryTst,
                                        obra = remota.summaryObra,
                                        localTexto = remota.summaryLocal
                                    )
                                    controller.baixarRemoto(remota.id, "pdf", name)
                                },
                                onExcel = {
                                    val name = ExportNames.remoteExcel(
                                        stored = remota.excelFileName,
                                        dataHorarioMs = remota.dataHorarioMs,
                                        createdAt = remota.createdAt,
                                        tstResponsavel = remota.summaryTst,
                                        obra = remota.summaryObra,
                                        localTexto = remota.summaryLocal
                                    )
                                    controller.baixarRemoto(remota.id, "excel", name)
                                },
                                onGerarAnexos = { controller.forcarGerarAnexosRemoto(remota.id) },
                                onExcluir = { confirmarExclusao = remota }
                            )
                        }
                    }
                }

            }
        }
    }
}

@Composable
private fun AcompAmbDossierHistoricoCard(
    dossier: br.com.htms.inspeccaocampo.data.AcompAmbDossier,
    showUser: Boolean,
    canEdit: Boolean,
    exportando: Boolean,
    onAbrir: () -> Unit,
    onExcel: () -> Unit,
    onExcluir: () -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            val whenMs = dossier.updatedAt ?: dossier.createdAt
            if (whenMs != null) {
                Text(formatDateTimeBr(whenMs), fontWeight = FontWeight.Bold)
            }
            Text(
                "Tipo: Acompanhamento Ambiental",
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary
            )
            if (showUser && !dossier.username.isNullOrBlank()) {
                Text("Usuário: ${dossier.username}", style = MaterialTheme.typography.labelLarge)
            }
            Text(
                "Obra: ${dossier.obra}",
                maxLines = 2,
                overflow = TextOverflow.Ellipsis,
                style = MaterialTheme.typography.titleSmall
            )
            Text("Ano: ${dossier.ano}")
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (canEdit) {
                    PortalButton(
                        onClick = onAbrir,
                        enabled = !exportando,
                        modifier = Modifier.weight(1f)
                    ) { Text("Abrir") }
                }
                PortalOutlinedButton(
                    onClick = onExcel,
                    enabled = !exportando,
                    modifier = Modifier.weight(1f)
                ) {
                    ButtonLoadingContent(
                        loading = exportando,
                        idleText = "Excel",
                        loadingText = "..."
                    )
                }
                if (canEdit) {
                    TextButton(onClick = onExcluir, enabled = !exportando) {
                        Text("Excluir")
                    }
                }
            }
        }
    }
}

@Composable
private fun RemDossierHistoricoCard(
    dossier: br.com.htms.inspeccaocampo.data.RemDossier,
    showUser: Boolean,
    canEdit: Boolean,
    exportando: Boolean,
    onAbrir: () -> Unit,
    onExcel: () -> Unit,
    onExcluir: () -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            val whenMs = dossier.updatedAt ?: dossier.createdAt
            if (whenMs != null) {
                Text(formatDateTimeBr(whenMs), fontWeight = FontWeight.Bold)
            }
            Text(
                "Tipo: REM Segurança — Obras",
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary
            )
            if (showUser && !dossier.username.isNullOrBlank()) {
                Text("Usuário: ${dossier.username}", style = MaterialTheme.typography.labelLarge)
            }
            Text(
                "Obra: ${dossier.obra}",
                maxLines = 2,
                overflow = TextOverflow.Ellipsis,
                style = MaterialTheme.typography.titleSmall
            )
            Text("Ano: ${dossier.ano}")
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (canEdit) {
                    PortalButton(
                        onClick = onAbrir,
                        enabled = !exportando,
                        modifier = Modifier.weight(1f)
                    ) { Text("Abrir") }
                }
                PortalOutlinedButton(
                    onClick = onExcel,
                    enabled = !exportando,
                    modifier = Modifier.weight(1f)
                ) {
                    ButtonLoadingContent(
                        loading = exportando,
                        idleText = "Excel",
                        loadingText = "..."
                    )
                }
                if (canEdit) {
                    TextButton(onClick = onExcluir, enabled = !exportando) {
                        Text("Excluir")
                    }
                }
            }
        }
    }
}

@Composable
private fun RemotoCard(
    remota: RemoteInspection,
    showUser: Boolean,
    canDelete: Boolean,
    canForceGenerate: Boolean = false,
    baixandoPdf: Boolean = false,
    baixandoExcel: Boolean = false,
    gerandoAnexos: Boolean = false,
    ocupado: Boolean = false,
    onPdf: () -> Unit,
    onExcel: () -> Unit,
    onGerarAnexos: () -> Unit = {},
    onExcluir: () -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            Text(
                formatDateTimeBr(remota.dataHorarioMs ?: remota.createdAt),
                fontWeight = FontWeight.Bold
            )
            Text(
                "Tipo: ${remota.formTipoRotulo}",
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary
            )
            if (showUser && !remota.username.isNullOrBlank()) {
                Text("Usuário: ${remota.username}", style = MaterialTheme.typography.labelLarge)
            }
            if (!remota.summaryObra.isNullOrBlank()) {
                Text(
                    "Obra: ${remota.summaryObra}",
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    style = MaterialTheme.typography.titleSmall
                )
            }
            Text(
                remota.summaryTst,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                style = MaterialTheme.typography.titleSmall
            )
            Text(
                "Local: ${remota.summaryLocal.replace("\n", " | ")}",
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            if (!remota.summaryEfetivo.isNullOrBlank()) {
                Text("Efetivo: ${remota.summaryEfetivo}")
            }
            if (!remota.hasPdf && !remota.hasExcel && remota.hasJson) {
                Text(
                    "PDF/Excel pendentes (dados no servidor).",
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.error
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (remota.hasPdf) {
                    PortalOutlinedButton(onClick = onPdf, enabled = !ocupado, modifier = Modifier.weight(1f)) {
                        ButtonLoadingContent(
                            loading = baixandoPdf,
                            loadingText = "PDF...",
                            idleText = "Baixar PDF"
                        )
                    }
                }
                if (remota.hasExcel) {
                    PortalOutlinedButton(onClick = onExcel, enabled = !ocupado, modifier = Modifier.weight(1f)) {
                        ButtonLoadingContent(
                            loading = baixandoExcel,
                            loadingText = "Excel...",
                            idleText = "Baixar Excel"
                        )
                    }
                }
            }
            if (canForceGenerate) {
                PortalOutlinedButton(
                    onClick = onGerarAnexos,
                    enabled = !ocupado,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    ButtonLoadingContent(
                        loading = gerandoAnexos,
                        loadingText = "Gerando...",
                        idleText = if (remota.hasPdf || remota.hasExcel) {
                            "Regenerar PDF/Excel"
                        } else {
                            "Gerar PDF/Excel"
                        }
                    )
                }
            }
            if (canDelete) {
                TextButton(
                    onClick = onExcluir,
                    enabled = !ocupado,
                    modifier = Modifier.align(Alignment.End)
                ) {
                    Text("Excluir", color = MaterialTheme.colorScheme.error)
                }
            }
        }
    }
}

@Composable
private fun HistoricoCard(
    inspecao: InspecaoCompleta,
    exportando: Boolean,
    sincronizando: Boolean,
    onEditar: () -> Unit,
    onPdf: () -> Unit,
    onExcel: () -> Unit,
    onReenviar: () -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            Text(formatDateTimeBr(inspecao.criadoEm), fontWeight = FontWeight.Bold)
            Text(
                "Tipo: ${inspecao.formTipo.rotulo}",
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary
            )
            val obra = inspecao.obraResumo()
            if (obra.isNotBlank()) {
                Text(
                    "Obra: $obra",
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    style = MaterialTheme.typography.titleSmall
                )
            }
            Text(
                inspecao.responsavelResumo(),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                style = MaterialTheme.typography.titleSmall
            )
            Text(
                "Local: ${inspecao.localResumo().replace("\n", " | ")}",
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            if (inspecao.form.efetivo.isNotBlank()) {
                Text("Efetivo: ${inspecao.form.efetivo}")
            }
            Text(
                if (inspecao.enviadoRemoto) "Servidor: enviado"
                else "Servidor: pendente — use Sincronizar para forçar",
                style = MaterialTheme.typography.labelMedium,
                color = if (inspecao.enviadoRemoto) {
                    MaterialTheme.colorScheme.primary
                } else {
                    MaterialTheme.colorScheme.error
                }
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                TextButton(onClick = onEditar, enabled = !exportando && !sincronizando) {
                    Text("Editar")
                }
                if (!inspecao.enviadoRemoto) {
                    PortalOutlinedButton(
                        onClick = onReenviar,
                        enabled = !exportando && !sincronizando
                    ) {
                        Text("Reenviar")
                    }
                }
                PortalOutlinedButton(onClick = onPdf, enabled = !exportando, modifier = Modifier.weight(1f)) {
                    ButtonLoadingContent(
                        loading = exportando,
                        loadingText = "PDF...",
                        idleText = "PDF"
                    )
                }
                PortalOutlinedButton(onClick = onExcel, enabled = !exportando, modifier = Modifier.weight(1f)) {
                    Text("Excel")
                }
            }
        }
    }
}

/** dd/MM/yyyy → (ano, mês 1-12, dia) ou null se inválido/vazio. */
private fun parseDateBrYmd(raw: String): Triple<Int, Int, Int>? {
    val s = raw.trim()
    if (s.isEmpty()) return null
    val parts = s.split('/', '-', '.')
    if (parts.size != 3) return null
    val d = parts[0].toIntOrNull() ?: return null
    val m = parts[1].toIntOrNull() ?: return null
    val y = parts[2].toIntOrNull() ?: return null
    if (y !in 2000..2100 || m !in 1..12 || d !in 1..31) return null
    return Triple(y, m, d)
}

/** Aproximação UTC do início/fim do dia (para filtro do consolidado no servidor). */
private fun ymdToEpochMs(ymd: Triple<Int, Int, Int>, endOfDay: Boolean): Long {
    val (y, m, d) = ymd
    // Algoritmo civil → dias desde epoch (Howard Hinnant), sem dependência de platform calendar.
    val yr = if (m <= 2) y - 1 else y
    val mp = if (m <= 2) m + 9 else m - 3
    val era = if (yr >= 0) yr / 400 else (yr - 399) / 400
    val yoe = yr - era * 400
    val doy = (153 * mp + 2) / 5 + d - 1
    val doe = yoe * 365 + yoe / 4 - yoe / 100 + doy
    val days = era * 146097L + doe - 719468L
    val dayMs = 86_400_000L
    return if (endOfDay) days * dayMs + dayMs - 1 else days * dayMs
}

private fun ymdOfEpoch(epochMs: Long): Triple<Int, Int, Int>? =
    parseDateBrYmd(formatDateBr(epochMs).take(10))

private fun compareYmd(a: Triple<Int, Int, Int>, b: Triple<Int, Int, Int>): Int {
    val byY = a.first.compareTo(b.first)
    if (byY != 0) return byY
    val byM = a.second.compareTo(b.second)
    if (byM != 0) return byM
    return a.third.compareTo(b.third)
}

private fun dataNoPeriodo(
    epochMs: Long,
    de: Triple<Int, Int, Int>?,
    ate: Triple<Int, Int, Int>?
): Boolean {
    if (de == null && ate == null) return true
    val ymd = ymdOfEpoch(epochMs) ?: return true
    if (de != null && compareYmd(ymd, de) < 0) return false
    if (ate != null && compareYmd(ymd, ate) > 0) return false
    return true
}

@Composable
private fun RelSegDossierHistoricoCard(
    dossier: br.com.htms.inspeccaocampo.data.RelSegDossier,
    showUser: Boolean,
    canEdit: Boolean,
    exportando: Boolean,
    onAbrir: () -> Unit,
    onPptx: () -> Unit,
    onExcluir: () -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors()
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            Text("${dossier.obra} — ${dossier.mes.toString().padStart(2, '0')}/${dossier.ano}", fontWeight = FontWeight.SemiBold)
            Text("Tipo: Relatório de segurança", style = MaterialTheme.typography.bodySmall)
            if (showUser && !dossier.username.isNullOrBlank()) {
                Text("Usuário: ${dossier.username}", style = MaterialTheme.typography.bodySmall)
            }
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                if (canEdit) {
                    TextButton(onClick = onAbrir) { Text("Abrir") }
                }
                TextButton(onClick = onPptx, enabled = !exportando) {
                    Text(if (exportando) "…" else "PPTX")
                }
                if (canEdit) {
                    TextButton(onClick = onExcluir) { Text("Excluir") }
                }
            }
        }
    }
}
